import { render, staticRenderFns } from "./DistributorSelector.vue?vue&type=template&id=2f7da838&"
import script from "./DistributorSelector.vue?vue&type=script&lang=js&"
export * from "./DistributorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports